import { CommonModule } from '@angular/common'; // Required for *ngIf, *ngTemplateOutlet
import { ChangeDetectionStrategy, Component, ContentChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-table-wrapper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './table-wrapper.component.html',
  styleUrls: ['./table-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // Good for presentational components
})
export class TableWrapperComponent {
  @ContentChild('tableHeader') tableHeaderRef!: TemplateRef<any>;
  @ContentChild('tableSubHeader') tableSubHeaderRef!: TemplateRef<any>;
  @ContentChild('tableBody') tableBodyRef!: TemplateRef<any>;
  @ContentChild('tableFooter') tableFooterRef!: TemplateRef<any>;
}
